<div class="map-toolbar" *ngIf="enabledFeature">
    <button
            matIconButton
            class="mat-icon-toggle-button"
            [class.selected]="displayPanel"
            type="button"
            matTooltip="{{ !displayPanel ? 'Search Results' : null }}"
            (click)="togglePanelDisplay()"
            matTooltipPosition="right">
        <mat-icon>manage_search</mat-icon>
    </button>
    <div class="toolbar-panel-container" [hidden]="!displayPanel">
        <div class="search-panel-sticky-container">
            <div class="search-summary-sticky">
                <app-search-summary-panel [searchState]="searchQueryService.searchState$ | async"
                                          [config]="searchPanelConfig"
                                          [is3DMode]="is3DMode"></app-search-summary-panel>
                <mat-divider></mat-divider>
            </div>
            <div class="search-results-scroll">
                <app-list-search-results></app-list-search-results>
            </div>
        </div>
        <!--    <app-search-summary-panel [searchState]="searchQueryService.searchState$ | async" [config]="searchPanelConfig"></app-search-summary-panel>-->
        <!--    <mat-divider></mat-divider>-->
        <!--    &lt;!&ndash; List Results &ndash;&gt;-->
        <!--    <app-list-search-results class></app-list-search-results>-->
    </div>
</div>
